import { render, staticRenderFns } from "./ThreadContent.vue?vue&type=template&id=6bba479e&scoped=true"
import script from "./ThreadContent.vue?vue&type=script&lang=js"
export * from "./ThreadContent.vue?vue&type=script&lang=js"
import style0 from "./ThreadContent.vue?vue&type=style&index=0&id=6bba479e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba479e",
  null
  
)

export default component.exports